import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import tiLogoMark from '../assets/TI-logo-no-text.png';
import ThemeToggle from './ThemeToggle';
import './WaitingRoom.css';

export default function WaitingRoom() {
  const { logout } = useAuth();

  return (
    <div className="waiting-room">
      <ThemeToggle className="theme-toggle-corner" />
      <div className="waiting-content">
        <img src={tiLogoMark} alt="Terra Inspectioneering" className="waiting-logo" />
        <h1 className="waiting-title">Terra Inspectioneering Base</h1>
        <div className="waiting-badge">Pending Approval</div>
        <p className="waiting-message">
          Your account is pending approval.<br />
          An admin will assign your role shortly.
        </p>
        <button className="waiting-signout-btn" onClick={logout}>
          Sign Out
        </button>
      </div>
    </div>
  );
}
